var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"photos-container",attrs:{"name":"list-animated"}},_vm._l((_vm.photos),function(photo){return _c('photo',{key:photo.id,staticClass:"list-animated-item",attrs:{"src":photo.src},on:{"remove":function($event){_vm.photos.splice(_vm.photos.findIndex(p => p.id === photo.id), 1)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }